import { render, staticRenderFns } from "./order-statistic.vue?vue&type=template&id=2a6d18d3&scoped=true&"
import script from "./order-statistic.vue?vue&type=script&lang=js&"
export * from "./order-statistic.vue?vue&type=script&lang=js&"
import style0 from "./order-statistic.vue?vue&type=style&index=0&id=2a6d18d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d18d3",
  null
  
)

export default component.exports